import { useEffect, useState } from "react";

type ButtonAnimationProps = {
  color?: "black" | "white";
};

export default function ButtonAnimation({ color }: ButtonAnimationProps) {
  const [buttonAnimation, setButtonAnimation] = useState(false);

  useEffect(() => {
    // Initialize a timer that runs every 10 seconds
    const timer = setInterval(() => {
      // First toggle: set to true immediately
      setButtonAnimation(true);
      // Second toggle: set to false after 500ms
      setTimeout(() => {
        setButtonAnimation(false);
        // Third toggle: set to true after another 500ms
        setTimeout(() => {
          setButtonAnimation(true);
          // Fourth toggle: set to false after another 500ms
          setTimeout(() => {
            setButtonAnimation(false);
          }, 300);
        }, 300);
      }, 300);
    }, 2500); // Adjusted to 10 seconds for clarity

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {!buttonAnimation ? (
        <img
          src={`${color === "white" ? "/images/icons/button-up.svg" : "/images/icons/button-up-black.svg"}`}
        />
      ) : (
        <img
          src={`${color === "white" ? "/images/icons/button-down.svg" : "/images/icons/button-down-black.svg"}`}
        />
      )}
    </>
  );
}
